// pages/Reservas.js
import React, { useState, useEffect, useRef } from 'react';


import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";


import {
  Table,Dropdown,
  Button,
  Modal,
  Form,
  Input,
  Select,
  Space,
  Typography,
  message,
  Tag,
  Tooltip,
  Row,
  Col,
  Popconfirm,
  Badge,
  Statistic,
  DatePicker,
  Card,
  Tabs,
  Steps,
  Collapse
} from 'antd';
import {
  FileTextOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  SearchOutlined,
  ReloadOutlined,
  CalendarOutlined,
  DollarOutlined,
  CreditCardOutlined,
  SaveOutlined,
  CloseOutlined,MoreOutlined
} from '@ant-design/icons';

import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';


import dayjs from 'dayjs';
import { BASE_URL } from '../utils/constants';

import PageContainer from '../components/PageContainer';


import DepositosReserva from '../components/DepositosReserva';
import CargosReserva from '../components/CargosReserva';
import Facturacion from './Facturacion';

const { Title, Text } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
const { Step } = Steps;
const { Panel } = Collapse;

const Reservas = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [showSynergy, setShowSynergy] = useState(false);
  const [showScheduler, setShowScheduler] = useState(false);

// Añade estos estados después de los existentes
const [buscandoAgencias, setBuscandoAgencias] = useState(false);
const [buscandoSubagencias, setBuscandoSubagencias] = useState(false);
const [agenciasFiltradas, setAgenciasFiltradas] = useState([]);
const [subagenciasFiltradas, setSubagenciasFiltradas] = useState([]);  


const [opcionesAgencias, setOpcionesAgencias] = useState([]);
const [opcionesSubagencias, setOpcionesSubagencias] = useState([]);

  const [facturacionModalVisible, setFacturacionModalVisible] = useState(false);
  const [reservaSeleccionada, setReservaSeleccionada] = useState(null);  

  const [depositosModalVisible, setDepositosModalVisible] = useState(false);

  const [cargosModalVisible, setCargosModalVisible] = useState(false);
  const [reservaCargos, setReservaCargos] = useState(null);  
  
  // Estados
  const [agencias, setAgencias] = useState([]);  
  const [subagencias, setSubagencias] = useState([]);
  const [particulares, setParticulares] = useState([]);
  const [paises, setPaises] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [regimenes, setRegimenes] = useState([]);
  const [tiposCliente, setTiposCliente] = useState([]);
  const [politicasCancelacion, setPoliticasCancelacion] = useState([]);
  const [idiomas, setIdiomas] = useState([]);
  const [tiposComunicacion, setTiposComunicacion] = useState([]);
  const [estadosReserva, setEstadosReserva] = useState([]);
  const [series, setSeries] = useState([]);
  const [habitacionesVenta, setHabitacionesVenta] = useState([]);
  const [tiposFacturacion, setTiposFacturacion] = useState([]);
    
  const [reservas, setReservas] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentReserva, setCurrentReserva] = useState(null);
  const [reservaDepositos,setReservaDepositos] = useState([])  
  const [form] = Form.useForm();
  const [tableLoading, setTableLoading] = useState(false);

  const [cargosMaestros, setCargosMaestros] = useState([]);  
    

  // Agregar estos estados después de los existentes
  const [lineasReserva, setLineasReserva] = useState([]);



    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 50,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100', '200']
    });  

    const [estadisticas, setEstadisticas] = useState({
        total: 0,
        activas: 0,
        facturadas: 0,
        anuladas: 0
    });   
    
const [modalBusquedaVisible, setModalBusquedaVisible] = useState(false);
const [tipoBusqueda, setTipoBusqueda] = useState(''); // 'agencia', 'subagencia', 'particular'
const [datosBusqueda, setDatosBusqueda] = useState([]);
const [filtroBusqueda, setFiltroBusqueda] = useState('');
const [cargandoBusqueda, setCargandoBusqueda] = useState(false);
const [paginacionBusqueda, setPaginacionBusqueda] = useState({
  current: 1,
  pageSize: 10,
  total: 0
});    

// const [filtrosTemp, setFiltrosTemp] = useState({
//   fechaEntrada: null,
//   fechaSalida: null,
//   agencia: '',
//   subagencia: '',
//   localizador: '',
//   numReserva: '',
//   nombreCliente: ''
// });

// const [filtrosActivos, setFiltrosActivos] = useState({
//   fechaEntrada: null,
//   fechaSalida: null,
//   agencia: '',
//   subagencia: '',
//   localizador: '',
//   numReserva: '',
//   nombreCliente: ''
// });
  
  // Estados para filtros
  const [filtros, setFiltros] = useState({
    fechaEntrada: null,
    fechaSalida: null,
    agencia: '',
    subagencia: '',
    localizador: '',
    numReserva: '',
    nombreCliente: ''
  });
  
  const [opciones, setOpciones] = useState([]);
  
  // Estados para modo edición/creación
  const [editMode, setEditMode] = useState(false);
  
  
  // Cargar datos iniciales
  useEffect(() => {
    fetchReservas();
    fetchDatosMaestros();

    buscarAgencias('');
    buscarSubagencias('');    
  }, [id]);

  useEffect(() => {
    const calcularTotalHabitaciones = () => {
      const values = form.getFieldsValue();
      const total = (values.I_ || 0) + (values.DO || 0) + (values.TR || 0) + 
                  (values.CU || 0) + (values.QU || 0);
      form.setFieldValue('Habitaciones', total);
    };

    // Escuchar cambios en los campos de habitaciones
    const { I_, DO, TR, CU, QU } = form.getFieldsValue();
    calcularTotalHabitaciones();
  }, [form, form.getFieldsValue()?.I_, form.getFieldsValue()?.DO, 
      form.getFieldsValue()?.TR, form.getFieldsValue()?.CU, form.getFieldsValue()?.QU]);  
  
  useEffect(() => {
    if (currentReserva) {
      fetchLineasReserva(currentReserva.NumReserva);
    }
  }, [currentReserva]);

  const fetchDatosMaestros = async () => {
    try {
      const token = localStorage.getItem('token');
      
      // Cargar todas las fuentes de datos en paralelo
      const requests = [
        axios.get(`${BASE_URL}/api/agencias`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${BASE_URL}/api/subagencias`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${BASE_URL}/api/particulares`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${BASE_URL}/api/paises`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${BASE_URL}/api/provincias`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${BASE_URL}/api/tiposregimen`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${BASE_URL}/api/tiposclientes`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${BASE_URL}/api/cancelaciones`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${BASE_URL}/api/idiomas`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${BASE_URL}/api/tipos-comunicacion`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${BASE_URL}/api/reservas-estados`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${BASE_URL}/api/series`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${BASE_URL}/api/habitacionesventa`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${BASE_URL}/api/tipos-facturacion`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${BASE_URL}/api/cargos`, { headers: { Authorization: `Bearer ${token}` } }),
        axios.get(`${BASE_URL}/api/opciones/hotel`, { headers: { Authorization: `Bearer ${token}` } })
      ];
      
      const responses = await Promise.all(requests);
      
      setAgencias(responses[0].data.data || []);
      setSubagencias(responses[1].data.data || []);
      setParticulares(responses[2].data.data || []);
      setPaises(responses[3].data.data || []);
      setProvincias(responses[4].data.data || []);
      setRegimenes(responses[5].data.data || []);
      setTiposCliente(responses[6].data.data || []);
      setPoliticasCancelacion(responses[7].data.data || []);
      setIdiomas(responses[8].data.data || []);
      setTiposComunicacion(responses[9].data.data || []);
      setEstadosReserva(responses[10].data.data || []);
      setSeries(responses[11].data.data || []);
      setHabitacionesVenta(responses[12].data.data || []);
      setTiposFacturacion(responses[13].data.data || []);
      setCargosMaestros(responses[14].data.data || []);
      setOpciones(responses[15].data.data || []);
      
      // console.log('✅ Datos maestros cargados ',opciones[0]);
    } catch (error) {
      console.error('Error cargando datos maestros:', error);
      message.error('Error al cargar datos maestros');
    }
  };
  

  // Agrega esto en el render o en un useEffect para los estilos
  useEffect(() => {
    // Crear estilos dinámicamente
    const style = document.createElement('style');
    style.textContent = `
      .linea-habitacion {
        border-bottom: 1px solid #f0f0f0 !important;
      }
      
      .linea-habitacion:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(0,0,0,0.05);
      }
      
      .separador-habitacion {
        height: 2px;
        background: linear-gradient(90deg, transparent, #1890ff, transparent);
        margin: 8px 0;
        opacity: 0.3;
      }
      
      .celda-linea {
        font-weight: 600;
        color: #1890ff;
      }
      
      .celda-ocupante {
        font-weight: 500;
        color: #666;
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

useEffect(() => {
  // Cargar agencias iniciales al montar el componente
  const cargarAgenciasIniciales = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/agencias?pageSize=50`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      const opciones = (response.data.data || []).map(agencia => ({
        value: agencia.Codigo,
        label: `${agencia.Codigo} - ${agencia.Nombre}`
      }));
      
      setOpcionesAgencias(opciones);
    } catch (error) {
      console.error('Error cargando agencias iniciales:', error);
    }
  };
  
  const cargarSubagenciasIniciales = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/subagencias?pageSize=50`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      const opciones = (response.data.data || []).map(sub => ({
        value: sub.Codigo,
        label: `${sub.Codigo} - ${sub.Nombre}`
      }));
      
      setOpcionesSubagencias(opciones);
    } catch (error) {
      console.error('Error cargando subagencias iniciales:', error);
    }
  };
  
  cargarAgenciasIniciales();
  cargarSubagenciasIniciales();
}, []);  

    // const fetchReservas = async (page = pagination.current, pageSize = pagination.pageSize) => {
    // setTableLoading(true);
    // try {
    //     const token = localStorage.getItem('token');
        
    //     const queryParams = new URLSearchParams({
    //     page: page,
    //     pageSize: pageSize,
    //     ...(filtros.fechaEntrada && {
    //         fechaEntradaDesde: filtros.fechaEntrada[0].format('YYYY-MM-DD'),
    //         fechaEntradaHasta: filtros.fechaEntrada[1].format('YYYY-MM-DD')
    //     }),
    //     ...(filtros.fechaSalida && {
    //         fechaSalidaDesde: filtros.fechaSalida[0].format('YYYY-MM-DD'),
    //         fechaSalidaHasta: filtros.fechaSalida[1].format('YYYY-MM-DD')
    //     }),
    //     ...(filtros.agencia && { agencia: filtros.agencia }),
    //     ...(filtros.subagencia && { subagencia: filtros.subagencia }),
    //     ...(filtros.localizador && { localizador: filtros.localizador }),
    //     ...(filtros.numReserva && { numReserva: filtros.numReserva }),
    //     ...(filtros.nombreCliente && { nombreCliente: filtros.nombreCliente })
    //     });
        
    //     const response = await axios.get(
    //     `${BASE_URL}/api/reservas?${queryParams.toString()}`,
    //     { headers: { Authorization: `Bearer ${token}` } }
    //     );
        

    //     console.log(" Reservas => ",response.data.data);
        
    //     setReservas(response.data.data);
    //     setFilteredData(response.data.data);
        
    //     if (response.data.estadisticas) {
    //         setEstadisticas(response.data.estadisticas);
    //     }        
        
    //     // Actualizar paginación
    //     setPagination(prev => ({
    //         ...prev,
    //         current: page,
    //         pageSize: pageSize,
    //         total: response.data.pagination?.total || 0
    //     }));
        
    // } catch (error) {
    //     message.error('Error al cargar las reservas');
    //     console.error('Error fetchReservas:', error);
    // } finally {
    //     setTableLoading(false);
    // }
    // };  

// const fetchReservas = async (page = pagination.current, pageSize = pagination.pageSize) => {
//   setTableLoading(true);
//   try {
//     const token = localStorage.getItem('token');
    
//     const queryParams = new URLSearchParams({
//       page: page,
//       pageSize: pageSize,
//       ...(filtrosActivos.fechaEntrada && filtrosActivos.fechaEntrada[0] && filtrosActivos.fechaEntrada[1] && {
//         fechaEntradaDesde: filtrosActivos.fechaEntrada[0].format('YYYY-MM-DD'),
//         fechaEntradaHasta: filtrosActivos.fechaEntrada[1].format('YYYY-MM-DD')
//       }),
//       ...(filtrosActivos.fechaSalida && filtrosActivos.fechaSalida[0] && filtrosActivos.fechaSalida[1] && {
//         fechaSalidaDesde: filtrosActivos.fechaSalida[0].format('YYYY-MM-DD'),
//         fechaSalidaHasta: filtrosActivos.fechaSalida[1].format('YYYY-MM-DD')
//       }),
//       ...(filtrosActivos.agencia && { agencia: filtrosActivos.agencia }),
//       ...(filtrosActivos.subagencia && { subagencia: filtrosActivos.subagencia }),
//       ...(filtrosActivos.localizador && { localizador: filtrosActivos.localizador }),
//       ...(filtrosActivos.numReserva && { numReserva: filtrosActivos.numReserva }),
//       ...(filtrosActivos.nombreCliente && { nombreCliente: filtrosActivos.nombreCliente })
//     });
    
//     const response = await axios.get(
//       `${BASE_URL}/api/reservas?${queryParams.toString()}`,
//       { headers: { Authorization: `Bearer ${token}` } }
//     );
    
//     setReservas(response.data.data);
//     setFilteredData(response.data.data);
    
//     if (response.data.estadisticas) {
//       setEstadisticas(response.data.estadisticas);
//     }        
    
//     setPagination(prev => ({
//       ...prev,
//       current: page,
//       pageSize: pageSize,
//       total: response.data.pagination?.total || 0
//     }));
    
//   } catch (error) {
//     message.error('Error al cargar las reservas');
//     console.error('Error fetchReservas:', error);
//   } finally {
//     setTableLoading(false);
//   }
// };

  const fetchReservas = async (page = pagination.current, pageSize = pagination.pageSize) => {
    setTableLoading(true);
    try {
      const token = localStorage.getItem('token');
      
      // Construir query params con los filtros actuales
      const queryParams = new URLSearchParams({
        page: page,
        pageSize: pageSize,
      });
      
      // Añadir filtros solo si tienen valor
      if (filtros.fechaEntrada?.[0] && filtros.fechaEntrada?.[1]) {
        queryParams.append('fechaEntradaDesde', filtros.fechaEntrada[0].format('YYYY-MM-DD'));
        queryParams.append('fechaEntradaHasta', filtros.fechaEntrada[1].format('YYYY-MM-DD'));
      }
      
      if (filtros.fechaSalida?.[0] && filtros.fechaSalida?.[1]) {
        queryParams.append('fechaSalidaDesde', filtros.fechaSalida[0].format('YYYY-MM-DD'));
        queryParams.append('fechaSalidaHasta', filtros.fechaSalida[1].format('YYYY-MM-DD'));
      }
      
      if (filtros.agencia) {
        queryParams.append('agencia', filtros.agencia);
      }
      
      if (filtros.subagencia) {
        queryParams.append('subagencia', filtros.subagencia);
      }
      
      if (filtros.localizador) {
        queryParams.append('localizador', filtros.localizador);
      }
      
      if (filtros.numReserva) {
        queryParams.append('numReserva', filtros.numReserva);
      }
      
      if (filtros.nombreCliente) {
        queryParams.append('nombreCliente', filtros.nombreCliente);
      }
      
      const response = await axios.get(
        `${BASE_URL}/api/reservas?${queryParams.toString()}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      setReservas(response.data.data);
      setFilteredData(response.data.data);
      
      if (response.data.estadisticas) {
        setEstadisticas(response.data.estadisticas);
      }
      
      setPagination(prev => ({
        ...prev,
        current: page,
        pageSize: pageSize,
        total: response.data.pagination?.total || 0
      }));
      
    } catch (error) {
      message.error('Error al cargar las reservas');
      console.error('Error fetchReservas:', error);
    } finally {
      setTableLoading(false);
    }
  };

const fetchLineasReserva = async (numReserva) => {
  setLoadingLineas(true);
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(
      `${BASE_URL}/api/reservas/${numReserva}/lineas`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    
    setLineasReserva(response.data.data);
    // console.log(`✅ Líneas obtenidas: ${response.data.data.length}`);
  } catch (error) {
    console.error('Error obteniendo líneas:', error);
    message.error('Error al cargar las líneas de reserva');
  } finally {
    setLoadingLineas(false);
  }
};


  const fetchReserva = async (id) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/reservas/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      const reserva = response.data.data.cabecera;
      setCurrentReserva(reserva);
      setLineasReserva(response.data.data.lineas || []);
      setCargos(response.data.data.cargos || []);
      
      // Cargar datos en el formulario
        form.setFieldsValue({
            ...reserva,
            // Entrada: reserva.Entrada ? moment(reserva.Entrada) : null,
            // Salida: reserva.Salida ? moment(reserva.Salida) : null,
            // Fechareserva: reserva.Fechareserva ? moment(reserva.Fechareserva) : moment(),  // <-- Cargar existente
            // FechaBooking: reserva.FechaBooking ? moment(reserva.FechaBooking) : moment(),   // <-- Cargar existente
            // FechaUltimaModificacion: reserva.FechaUltimaModificacion ? moment(reserva.FechaUltimaModificacion) : null,
            // FechaHoraProforma: reserva.FechaHoraProforma ? moment(reserva.FechaHoraProforma) : null
            Entrada: reserva.Entrada ? dayjs(reserva.Entrada) : null,
            Salida: reserva.Salida ? dayjs(reserva.Salida) : null,

            Fechareserva: reserva.Fechareserva ? dayjs(reserva.Fechareserva) : dayjs(),
            FechaBooking: reserva.FechaBooking ? dayjs(reserva.FechaBooking) : dayjs(),
            FechaUltimaModificacion: reserva.FechaUltimaModificacion ? dayjs(reserva.FechaUltimaModificacion) : null,
            FechaHoraProforma: reserva.FechaHoraProforma ? dayjs(reserva.FechaHoraProforma) : null,
        });
      
    } catch (error) {
      message.error('Error al cargar la reserva');
      console.error('Error fetchReserva:', error);
    } finally {
      setLoading(false);
    }
  };
  
  const handleTableChange = (newPagination, filters, sorter) => {
    const { current, pageSize } = newPagination;
    fetchReservas(current, pageSize);
  };


  const editarReserva = (reserva) => {
    setEditMode(true);
    setCurrentReserva(reserva);
    setModalVisible(true);

    // mismo código que ya tenías
  };

  const handleNuevaReservaNueva = () => {
    navigate('/reservas/nueva');
  };

  const handleNuevaReserva = () => {
    setCreatingReserva(true);
    setEditMode(true);
    setCurrentReserva(null);
    setLineasReserva([]);
    setCargos([]);
    
    // Obtener último número de reserva
    obtenerUltimoNumeroReserva();
    
    // Resetear formulario con valores por defecto
    form.resetFields();
    form.setFieldsValue({
      codparti: '0',
      Nombre: 'HUESPED',
      Nacion: 'ESPAÑA',
      Idioma: 'CAS',
      Serie: 'A',
      Facturado: false,
      Anulada: false,
      Regimen: '',
      SerEntrada: '',
      SerSalida: '',
      RegMp: '0',
      FPago: 1,
      FacturarTasa: 0,
      TipoPrecio: 'M',
      I_: 0,
      DO: 0,
      TR: 0,
      CU: 0,
      QU: 0,
      Fechareserva: dayjs(),
      FechaBooking: dayjs(),
      Entrada: dayjs(),
      Salida: dayjs().add(1, 'day'),
      esGrupoHabitaciones: false,
      ReservadeBloqueo: false,
      NoReembolsable: false,
      AplicaDtoEarlyBooking: true,
      AplicaDtoDias: true
    });
  };
  
  const obtenerUltimoNumeroReserva = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/reservas/ultimo-numero`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      form.setFieldsValue({
        NumReserva: response.data.data.nuevoNumero
      });
      
    } catch (error) {
      console.error('Error obteniendo último número:', error);
    }
  };
  
  const obtenerUltimoLocalizador = async (agencia) => {
    if (!agencia) {
      message.warning('Primero seleccione una agencia');
      return;
    }
    
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${BASE_URL}/api/reservas/ultimo-localizador/${agencia}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      form.setFieldsValue({
        SNumero: response.data.data.nuevoLocalizador
      });
      
      message.success(`Localizador generado: ${response.data.data.nuevoLocalizador}`);
      
    } catch (error) {
      console.error('Error obteniendo último localizador:', error);
      message.error('Error al generar localizador');
    }
  };
  
  const handleGuardarReserva = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      const token = localStorage.getItem('token');
      
      console.log('📝 Datos a guardar:', values);
      
      // Preparar datos para enviar
        const datosReserva = {
            ...values,
            // Entrada: values.Entrada ? values.Entrada.format('YYYY-MM-DDT00:00:00') : null,
            // Salida: values.Salida ? values.Salida.format('YYYY-MM-DDT00:00:00') : null,
            // Fechareserva: values.Fechareserva ? values.Fechareserva.format('YYYY-MM-DDT00:00:00') : moment().format('YYYY-MM-DDT00:00:00'),
            // FechaBooking: values.FechaBooking ? values.FechaBooking.format('YYYY-MM-DDT00:00:00') : moment().format('YYYY-MM-DDT00:00:00'),
            // FechaUltimaModificacion: moment().format('YYYY-MM-DDTHH:mm:ss'),
            // FechaHoraProforma: values.FechaHoraProforma ? values.FechaHoraProforma.format('YYYY-MM-DDTHH:mm:ss') : null
            Entrada: values.Entrada ? values.Entrada.startOf('day').format('YYYY-MM-DDTHH:mm:ss') : null,
            Salida: values.Salida ? values.Salida.startOf('day').format('YYYY-MM-DDTHH:mm:ss') : null,
            Fechareserva: values.Fechareserva ? values.Fechareserva.startOf('day').format('YYYY-MM-DDTHH:mm:ss') : dayjs().startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
            FechaBooking: values.FechaBooking ? values.FechaBooking.startOf('day').format('YYYY-MM-DDTHH:mm:ss') : dayjs().startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
            FechaUltimaModificacion: dayjs().format('YYYY-MM-DDTHH:mm:ss'),
            FechaHoraProforma: values.FechaHoraProforma ? values.FechaHoraProforma.format('YYYY-MM-DDTHH:mm:ss') : null,
        };
      
      if (currentReserva) {
        // Actualizar reserva existente
        const response = await axios.put(
          `${BASE_URL}/api/reservas/${currentReserva.NumReserva}`,
          datosReserva,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
        message.success('Reserva actualizada correctamente');
        fetchReservas();
        setEditMode(false);
        setCurrentReserva(response.data.data);
        
      } else {
        // Crear nueva reserva
        const response = await axios.post(
          `${BASE_URL}/api/reservas`,
          datosReserva,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
        message.success('Reserva creada correctamente');
        
        // Redirigir a la nueva reserva
        const nuevaReservaId = response.data.data.cabecera.NumReserva;
        navigate(`/reservas/${nuevaReservaId}`);
        setCurrentReserva(response.data.data.cabecera);
        setLineasReserva(response.data.data.lineas || []);
        setCargos(response.data.data.cargos || []);
      }
      
    } catch (error) {
      console.error('❌ Error guardando reserva:', error);
      
      if (error.response?.data?.error) {
        message.error(error.response.data.error);
      } else if (error.response?.data?.details) {
        message.error(error.response.data.details);
      } else {
        message.error('Error al guardar la reserva');
      }
    } finally {
      setLoading(false);
    }
  };
  
  const handleCancelarEdicion = () => {
    setEditMode(false);
    setCreatingReserva(false);
    
    if (currentReserva) {
      // Recargar datos originales
      fetchReserva(currentReserva.NumReserva);
    } else {
      form.resetFields();
      setLineasReserva([]);
      setCargos([]);
    }
  };
  
  const handleEliminarReserva = async (numReserva) => {
    try {
      setTableLoading(true);
      const token = localStorage.getItem('token');
      
      await axios.delete(
        `${BASE_URL}/api/reservas/${numReserva}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Si estamos viendo esta reserva, redirigir a la lista
      if (currentReserva && currentReserva.NumReserva === numReserva) {
        navigate('/reservas');
        setCurrentReserva(null);
        setEditMode(false);
      }
      
      // Actualizar lista
      fetchReservas();
      
      message.success('Reserva eliminada correctamente');
      
    } catch (error) {
      message.error(error.response?.data?.error || 'Error al eliminar la reserva');
      console.error('Error handleDelete:', error);
    } finally {
      setTableLoading(false);
    }
  };
  
  const handleAnularReserva = async (numReserva) => {
    try {
      setTableLoading(true);
      const token = localStorage.getItem('token');
      
      await axios.patch(
        `${BASE_URL}/api/reservas/${numReserva}/anular`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Actualizar reserva actual si es la que estamos viendo
      if (currentReserva && currentReserva.NumReserva === numReserva) {
        fetchReserva(numReserva);
      }
      
      // Actualizar lista
      fetchReservas();
      
      message.success('Reserva anulada correctamente');
      
    } catch (error) {
      message.error(error.response?.data?.error || 'Error al anular la reserva');
      console.error('Error handleAnular:', error);
    } finally {
      setTableLoading(false);
    }
  };
  
const handleAplicarFiltros = () => {
  setFiltros(filtros);

  setPagination(prev => ({
      ...prev,
      current: 1
  }));
    
    
  fetchReservas(1, pagination.pageSize);
};
  
  // const handleLimpiarFiltros = () => {
  //   setFiltros({
  //     fechaEntrada: null,
  //     fechaSalida: null,
  //     agencia: '',
  //     subagencia: '',
  //     localizador: '',
  //     numReserva: '',
  //     nombreCliente: ''
  //   });
    
  //   // Recargar sin filtros
  //   setTimeout(() => fetchReservas(), 100);
  // };

  const handleLimpiarFiltros = () => {
    const filtrosVacios = {
      fechaEntrada: null,
      fechaSalida: null,
      agencia: '',
      subagencia: '',
      localizador: '',
      numReserva: '',
      nombreCliente: ''
    };
    
    setFiltros(filtrosVacios);
    setPagination(prev => ({
      ...prev,
      current: 1
    }));
    
    // Recargar sin filtros
    fetchReservas(1, pagination.pageSize);
  };



const validarDisponibilidadHabitacion = async (numHabitacion) => {
  if (!numHabitacion) {
    setMensajeDisponibilidad('');
    return;
  }
  
  try {
    const valores = formLinea.getFieldsValue();
    const entrada = valores.Entrada?.format('YYYY-MM-DD');
    const salida = valores.Salida?.format('YYYY-MM-DD');
    
    if (!entrada || !salida) {
      setMensajeDisponibilidad('Primero seleccione fechas de entrada y salida');
      return;
    }
    
    const token = localStorage.getItem('token');
    const response = await axios.get(
      `${BASE_URL}/api/disponibilidad-habitacion?numhabitacion=${numHabitacion}&entrada=${entrada}&salida=${salida}&excluirReserva=${currentReserva?.NumReserva}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    
    if (response.data.disponible) {
      setMensajeDisponibilidad('✅ Habitación disponible');
    } else {
      setMensajeDisponibilidad('❌ Habitación ocupada en esas fechas');
    }
  } catch (error) {
    console.error('Error validando disponibilidad:', error);
    setMensajeDisponibilidad('Error al verificar disponibilidad');
  }
};

// Función para contar líneas con habitación asignada
const contarLineasConHabitacion = () => {
  if (!lineasReserva || lineasReserva.length === 0) return 0;
  
  // Contar habitaciones únicas con habitación asignada
  const lineasConHab = new Set();
  lineasReserva.forEach(l => {
    if (l.NumHab && l.Numocupante === 1) {
      lineasConHab.add(l.Linea);
    }
  });
  
  return lineasConHab.size;
};

// Función para contar líneas totales (solo primeras líneas de cada habitación)
const contarLineasTotales = () => {
  if (!lineasReserva || lineasReserva.length === 0) return 0;
  
  const lineasUnicas = new Set();
  lineasReserva.forEach(l => {
    if (l.Numocupante === 1 && l.NFactura === 0 && l.Anulada === 0) {
      lineasUnicas.add(l.Linea);
    }
  });
  
  return lineasUnicas.size;
};


const buscarDatos = async (tipo, filtro = '', pagina = 1) => {
  setCargandoBusqueda(true);
  try {
    const token = localStorage.getItem('token');
    let url = '';
    
    const queryParams = new URLSearchParams({
      page: pagina,
      pageSize: paginacionBusqueda.pageSize,
      ...(filtro && { search: filtro })
    });

    switch(tipo) {
      case 'agencia':
        url = `${BASE_URL}/api/agencias?${queryParams.toString()}`;
        break;
      case 'subagencia':
        url = `${BASE_URL}/api/subagencias?${queryParams.toString()}`;
        break;
      case 'particular':
        url = `${BASE_URL}/api/particulares?${queryParams.toString()}`;
        break;
      default:
        return;
    }

    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });

    setDatosBusqueda(response.data.data || []);
    setPaginacionBusqueda(prev => ({
      ...prev,
      current: pagina,
      total: response.data.pagination?.total || 0
    }));
  } catch (error) {
    console.error('Error buscando datos:', error);
    message.error('Error al buscar datos');
  } finally {
    setCargandoBusqueda(false);
  }
};

const seleccionarElemento = (elemento) => {
  console.log('Seleccionando elemento:', elemento, 'para tipo:', tipoBusqueda);

    switch (tipoBusqueda) {
        case 'agencia':            
            form.setFieldValue('Agencia', elemento.Codigo);

            console.log(" currentReserva => ",currentReserva);
            console.log(" FacturarTasa => ",elemento.enFactura);
            console.log(" elemanto => ",elemento);

            if (elemento.enFactura){
                form.setFieldValue("FacturarTasa",1)
            }else{form.setFieldValue("FacturarTasa",0)}

            if (elemento.credito){
                form.setFieldValue("FPago",0)
            }else{form.setFieldValue("FPago",1)}            
                     
            
            if (!currentReserva){
                console.log(" Limpio servicios ");
                form.setFieldValue('Regimen', '');
                form.setFieldValue('SerEntrada', '');
                form.setFieldValue('SerSalida', '');
            }

            console.log(" SerEntrada => ",form.getFieldValue('SerEntrada'));
  
            let regimenValue, serEntradaValue, serSalidaValue;
  
            // Usar los valores de la agencia
            if (elemento.Regimen && elemento.Regimen.trim() !== '') {
                regimenValue = elemento.Regimen;
            } else if (opciones[0] && opciones[0].Regimen && opciones[0].Regimen.trim() !== '') {
                //Si la agencia no tiene, usar opciones por defecto
                regimenValue = opciones[0].Regimen;
            } else {
                // Si no hay ninguno, usar 'PC' como valor por defecto
                regimenValue = 'PC';
            }
            console.log(" regimenValue => ",regimenValue,form.getFieldValue('SerEntrada'));
            
            form.setFieldValue('Regimen', regimenValue);
  
            // Actualizar servicios basados en el regimen
            // actualizarServiciosPorRegimen(regimenValue);
  
            // Para SerEntrada - respetar valores existentes si ya están establecidos
            const serEntradaActual = form.getFieldValue('SerEntrada');
            console.log(" serEntradaActual => ",serEntradaActual);
            
            if (!serEntradaActual) {
                if (elemento.SerEntrada && elemento.SerEntrada.trim() !== '') {
                    serEntradaValue = elemento.SerEntrada;
                } else if (opciones[0] && opciones[0].SerEntrada && opciones[0].SerEntrada.trim() !== '') {
                    serEntradaValue = opciones[0].SerEntrada;
                }
                if (serEntradaValue) {
                    form.setFieldValue('SerEntrada', serEntradaValue);
                }
            }
  
            // Para SerSalida - respetar valores existentes si ya están establecidos
            const serSalidaActual = form.getFieldValue('SerSalida');
            if (!serSalidaActual) {
                if (elemento.SerSalida && elemento.SerSalida.trim() !== '') {
                    serSalidaValue = elemento.SerSalida;
                } else if (opciones[0] && opciones[0].SerSalida && opciones[0].SerSalida.trim() !== '') {
                    serSalidaValue = opciones[0].SerSalida;
                }
                if (serSalidaValue) {
                    form.setFieldValue('SerSalida', serSalidaValue);
                }
            }
            // console.log('Opciones => ', opciones[0].Regimen,opciones[0].SerEntrada,opciones[0].SerSalida);
            // console.log("Regimenes => ", regimenValue, serEntradaValue, serSalidaValue);
  
            setAgenciaNombre(elemento.Nombre);
        break;

    case 'subagencia':
      form.setFieldsValue({SubAgen: elemento.Codigo});
      setSubagenciaNombre(elemento.Nombre);
      break;

    case 'particular':
      form.setFieldsValue({
        codparti: elemento.Codigo,
        Nombre: elemento.Nombre || 'HUESPED',
        Telefono: elemento.Telefono || '',
        CorreoElectronico: elemento.Email || '',
        Nacion: elemento.Pais || 'ESPAÑA'
      });
      form.setFieldValue('CodParti', elemento.Codigo);
      break;
  }

  // Fuerza repaint y validaciones
  form.validateFields();

  setModalBusquedaVisible(false);
};

const columnasPDF = [
  { header: "Reserva", field: "NumReserva" },
  { header: "Cliente", field: "Nombre" },
  { header: "Entrada", field: "FechaEntrada" },
  { header: "Salida", field: "FechaSalida" },
  { header: "Total", field: "Total" },
]; 

// Función para generar PDF con las reservas filtradas
const generarPDF = () => {
  try {
    // Crear documento PDF
    const doc = new jsPDF();
    
    // Obtener nombre del hotel de las opciones
    const nombreHotel = opciones[0]?.Nombre || 'HOTEL';
    
    // === CABECERA ===
    // Línea izquierda: nombre del hotel
    doc.setFontSize(20);
    doc.setTextColor(24, 144, 255); // Azul
    doc.text(nombreHotel, 14, 20);
    
    // Línea derecha: fecha y hora
    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100); // Gris
    const fechaHora = dayjs().format('DD/MM/YYYY HH:mm');
    const fechaTexto = `Generado: ${fechaHora}`;
    const fechaWidth = doc.getTextWidth(fechaTexto);
    doc.text(fechaTexto, doc.internal.pageSize.width - 14 - fechaWidth, 20);
    
    // Línea separadora
    doc.setDrawColor(200, 200, 200);
    doc.line(14, 25, doc.internal.pageSize.width - 14, 25);
    
    // Título del documento
    doc.setFontSize(16);
    doc.setTextColor(0, 0, 0);
    doc.text('LISTADO DE RESERVAS', 14, 35);
    
    // === FILTROS APLICADOS ===
    let filtrosArray = [];
    let filtrosY = 45;
    
    if (filtros.fechaEntrada?.[0]) {
      filtrosArray.push(`Entrada: ${filtros.fechaEntrada[0].format('DD/MM/YYYY')} - ${filtros.fechaEntrada[1].format('DD/MM/YYYY')}`);
    }
    if (filtros.fechaSalida?.[0]) {
      filtrosArray.push(`Salida: ${filtros.fechaSalida[0].format('DD/MM/YYYY')} - ${filtros.fechaSalida[1].format('DD/MM/YYYY')}`);
    }
    
    // Buscar nombres de agencia si están seleccionadas
    if (filtros.agencia) {
      const agencia = opcionesAgencias.find(a => a.value === filtros.agencia);
      filtrosArray.push(`Agencia: ${agencia ? agencia.label : filtros.agencia}`);
    }
    if (filtros.subagencia) {
      const subagencia = opcionesSubagencias.find(s => s.value === filtros.subagencia);
      filtrosArray.push(`Subagencia: ${subagencia ? subagencia.label : filtros.subagencia}`);
    }
    if (filtros.localizador) {
      filtrosArray.push(`Localizador: ${filtros.localizador}`);
    }
    if (filtros.numReserva) {
      filtrosArray.push(`Nº Reserva: ${filtros.numReserva}`);
    }
    if (filtros.nombreCliente) {
      filtrosArray.push(`Cliente: ${filtros.nombreCliente}`);
    }
    
    if (filtrosArray.length > 0) {
      doc.setFontSize(9);
      doc.setTextColor(80, 80, 80);
      doc.text('Filtros aplicados:', 14, filtrosY);
      
      // Mostrar filtros en múltiples líneas si son muchos
      let lineY = filtrosY + 6;
      let currentLine = '';
      
      filtrosArray.forEach((filtro, index) => {
        const testLine = currentLine ? `${currentLine}  •  ${filtro}` : `• ${filtro}`;
        const testWidth = doc.getTextWidth(testLine);
        
        if (testWidth < doc.internal.pageSize.width - 28) {
          currentLine = testLine;
        } else {
          doc.text(currentLine, 14, lineY);
          lineY += 5;
          currentLine = `• ${filtro}`;
        }
        
        if (index === filtrosArray.length - 1) {
          doc.text(currentLine, 14, lineY);
        }
      });
      
      filtrosY = lineY + 5;
    } else {
      doc.setFontSize(9);
      doc.setTextColor(150, 150, 150);
      doc.text('Sin filtros aplicados (mostrando todas las reservas)', 14, filtrosY);
      filtrosY += 6;
    }
    
    // === CONFIGURACIÓN DE COLUMNAS - FÁCIL DE MODIFICAR ===
    const columns = [
      { header: 'Nº Reserva', dataKey: 'numReserva', width: 20 },
      { header: 'Localizador', dataKey: 'localizador', width: 20 },
      { header: 'Cliente', dataKey: 'cliente', width: 35 },
      { header: 'Agencia', dataKey: 'agencia', width: 25 },
      { header: 'Entrada', dataKey: 'entrada', width: 18 },
      { header: 'Salida', dataKey: 'salida', width: 18 },
      { header: 'Hab', dataKey: 'habitaciones', width: 12 },
      { header: 'Pax', dataKey: 'pax', width: 12 },
      { header: 'Régimen', dataKey: 'regimen', width: 15 },
      { header: 'Importe (€)', dataKey: 'importe', width: 20 },
      { header: 'Estado', dataKey: 'estado', width: 18 },
      // Para añadir/quitar columnas, solo comenta o descomenta líneas arriba
      // También puedes ajustar los widths según necesites
    ];
    
    // Preparar datos
    const rows = filteredData.map(reserva => ({
      numReserva: reserva.NumReserva.toString(),
      localizador: reserva.SNumero || '-',
      cliente: (reserva.Nombre || 'HUESPED').substring(0, 20),
      agencia: (reserva.NomAgencia || reserva.Agencia || '-').substring(0, 15),
      entrada: dayjs(reserva.Entrada).format('DD/MM/YY'),
      salida: dayjs(reserva.Salida).format('DD/MM/YY'),
      habitaciones: reserva.Habitaciones?.toString() || '0',
      pax: reserva.Pax?.toString() || '0',
      regimen: reserva.Regimen || '-',
      importe: reserva.ImporteTotal ? parseFloat(reserva.ImporteTotal).toFixed(2) : '0.00',
      estado: reserva.Anulada ? 'Anulada' : reserva.Facturado ? 'Facturada' : 'Activa',
    }));
    
    // Generar tabla
    autoTable(doc, {
      columns: columns,
      body: rows,
      startY: filtrosY + 5,
      theme: 'striped',
      headStyles: { 
        fillColor: [24, 144, 255], 
        textColor: 255, 
        fontStyle: 'bold',
        halign: 'center'
      },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      margin: { top: 30 },
      styles: { 
        fontSize: 8,
        cellPadding: 2,
        overflow: 'ellipsis',
      },
      columnStyles: {
        importe: { halign: 'right' },
        habitaciones: { halign: 'center' },
        pax: { halign: 'center' },
        numReserva: { halign: 'center' },
      },
      didDrawPage: (data) => {
        // Número de página
        doc.setFontSize(8);
        doc.setTextColor(150, 150, 150);
        doc.text(
          `Página ${data.pageNumber}`,
          data.settings.margin.left,
          doc.internal.pageSize.height - 10
        );
        
        // Repetir cabecera en nuevas páginas?
        if (data.pageNumber > 1) {
          doc.setFontSize(8);
          doc.setTextColor(100, 100, 100);
          doc.text(`${nombreHotel} - ${fechaHora}`, 14, 15);
        }
      },
    });
    
    // === PIE DE PÁGINA CON TOTALES ===
    const finalY = doc.lastAutoTable.finalY || 20;
    
    // Línea separadora
    doc.setDrawColor(200, 200, 200);
    doc.line(14, finalY + 5, doc.internal.pageSize.width - 14, finalY + 5);
    
    // Totales
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.text(`Total reservas: ${filteredData.length}`, 14, finalY + 15);
    
    // Calcular importe total
    const importeTotal = filteredData.reduce((sum, r) => sum + (parseFloat(r.ImporteTotal) || 0), 0);
    doc.setFontSize(10);
    doc.setTextColor(24, 144, 255);
    doc.text(`Importe total: ${importeTotal.toFixed(2)} €`, 14, finalY + 23);
    
    // Resumen por estados (derecha)
    const activas = filteredData.filter(r => !r.Anulada && !r.Facturado).length;
    const facturadas = filteredData.filter(r => r.Facturado).length;
    const anuladas = filteredData.filter(r => r.Anulada).length;
    
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);
    const resumenTexto = `Activas: ${activas}  |  Facturadas: ${facturadas}  |  Anuladas: ${anuladas}`;
    const resumenWidth = doc.getTextWidth(resumenTexto);
    doc.text(resumenTexto, doc.internal.pageSize.width - 14 - resumenWidth, finalY + 15);
    
    // Guardar PDF
    doc.save(`reservas_${dayjs().format('YYYYMMDD_HHmm')}.pdf`);
    
    message.success(`PDF generado con ${filteredData.length} reservas`);
    
  } catch (error) {
    console.error('Error generando PDF:', error);
    message.error('Error al generar el PDF');
  }
};

  // Configuración de columnas para la tabla de reservas
  const columns = [
    {
      title: 'Nº Reserva',
      dataIndex: 'NumReserva',
      key: 'NumReserva',
      width: 100,
      sorter: (a, b) => a.NumReserva - b.NumReserva,
      // render: (num) => <Tag color="blue">#{num}</Tag>,

      render: (_, record) => (
        <div>
          <Tag color="blue">#{record.NumReserva}</Tag>,
          <div style={{ fontSize: '10px', marginTop: 4 }}>
            Loc: {record.SNumero}
          </div>
        </div>
      ),      
    },
    {
      title: 'Cliente',
      dataIndex: 'Nombre',
      key: 'Nombre',
      width: 200,
      ellipsis: true,
      render: (nombre, record) => (
        <div>
          <div><strong>{nombre}</strong></div>
          <div style={{ fontSize: '12px', color: '#999' }}>
            {record.Agencia} {record.NomAgencia} {record.SubAgen ? `- ${record.SubAgen}` : ''}
          </div>
        </div>
      ),
    },
    {
      title: 'Fechas reserva',
      key: 'fechareserva',
      width: 180,
      render: (_, record) => (
        <div>
          <div style={{ fontSize: '14px' }}>
            {dayjs(record.Fechareserva).format('DD/MM/YYYY')}
          </div>
        </div>
      ),
    },    
    {
      title: 'Fechas',
      key: 'fechas',
      width: 180,
      render: (_, record) => (
        <div>
          <div style={{ fontSize: '12px' }}>
            <CalendarOutlined /> Entrada: {dayjs(record.Entrada).format('DD/MM/YY')}
          </div>
          <div style={{ fontSize: '12px' }}>
            <CalendarOutlined /> Salida: {dayjs(record.Salida).format('DD/MM/YY')}
          </div>
        </div>
      ),
    },
    {
      title: 'Habitaciones / Pax',
      key: 'habitaciones',
      width: 150,
      render: (_, record) => (
        <div>
          {record.I_ > 0 && <Tag>IN: {record.I_}</Tag>}
          {record.DO > 0 && <Tag>DO: {record.DO}</Tag>}
          {record.TR > 0 && <Tag>TR: {record.TR}</Tag>}
          {record.CU > 0 && <Tag>CU: {record.CU}</Tag>}
          {record.QU > 0 && <Tag>QU: {record.QU}</Tag>}
          <div style={{ fontSize: '12px', marginTop: 4 }}>
            Total: {record.Habitaciones || 0} hab. {record.Pax || 0} pax.
          </div>
        </div>
      ),
    },
    {
      title: 'Estado',
      dataIndex: 'Anulada',
      key: 'Anulada',
      width: 100,
      render: (anulada, record) => (
        <Badge
          status={anulada ? 'error' : record.Facturado ? 'success' : 'processing'}
          text={anulada ? 'Anulada' : record.Facturado ? 'Facturada' : 'Activa'}
        />
      ),
    },
    {
      title: 'Regimen',
      dataIndex: 'Regimen',
      key: 'Regimen',
      width: 100,
    },
    {
      title: 'Importe',
      dataIndex: 'ImporteTotal',
      key: 'ImporteTotal',
      width: 120,
      render: (importe) => (
        <Text strong style={{ color: '#52c41a' }}>
          {importe ? `${parseFloat(importe).toFixed(2)} €` : '0.00 €'}
        </Text>
      ),
    },
{
  title: 'Acciones',
  key: 'acciones',
  width: 100,
  fixed: 'right',
  render: (_, record) => {

    const items = [

      // DEPÓSITOS
      {
        key: 'depositos',
        label: 'Depósitos',
        icon: <CreditCardOutlined />,
        onClick: () => {
          setReservaDepositos({
            Nombre: record.Nombre,
            NumReserva: record.NumReserva
          });
          setDepositosModalVisible(true);
        }
      },

      // CARGOS
      {
        key: 'cargos',
        label: 'Cargos',
        icon: <DollarOutlined />,
        onClick: () => {
          setReservaCargos({
            Nombre: record.Nombre,
            NumReserva: record.NumReserva
          });
          setCargosModalVisible(true);
        }
      },

      // EDITAR
      {
        key: 'editar',
        label: 'Editar',
        icon: <EditOutlined />,
        onClick: () => navigate(`/reservas/${record.NumReserva}`)
      },

      // ANULAR (solo si procede)
      ...(!record.Anulada && !record.Facturado ? [{
        key: 'anular',
        label: (
          <Popconfirm
            title="¿Anular esta reserva?"
            description="Esta acción marcará la reserva como anulada"
            onConfirm={() => handleAnularReserva(record.NumReserva)}
            okText="Sí"
            cancelText="No"
          >
            <span style={{ color: '#ff4d4f' }}>Anular</span>
          </Popconfirm>
        ),
        icon: <CloseOutlined />,
        danger: true
      }] : []),

      // FACTURACIÓN
      ...(!record.Facturado ? [{
        key: 'facturacion',
        label: 'Facturación',
        icon: <FileTextOutlined />,
        onClick: () => {
          setReservaSeleccionada(record);
          setFacturacionModalVisible(true);
        }
      }] : []),

      // ELIMINAR
      ...(!record.Facturado ? [{
        key: 'eliminar',
        label: (
          <Popconfirm
            title="¿Eliminar esta reserva?"
            description="Esta acción no se puede deshacer"
            onConfirm={() => handleEliminarReserva(record.NumReserva)}
            okText="Sí"
            cancelText="No"
            okButtonProps={{ danger: true }}
          >
            <span style={{ color: '#ff4d4f' }}>Eliminar</span>
          </Popconfirm>
        ),
        icon: <DeleteOutlined />,
        danger: true
      }] : []),
    ];

    return (
      <Dropdown
        menu={{ items }}
        trigger={['click']}
        placement="bottomRight"
      >
        <Button icon={<MoreOutlined />} />
      </Dropdown>
    );
  },
},

    // {
    //   title: 'Acciones',
    //   key: 'acciones',
    //   width: 180,
    //   fixed: 'right',
    //   render: (_, record) => (
    //     <Space>
    //       <Tooltip title="Depósitos">
    //         <Button
    //           type="link"
    //           icon={<CreditCardOutlined />}
    //           size="small"
    //           onClick={() =>{
    //                setReservaDepositos(
    //                   { Nombre:record.Nombre,NumReserva:record.NumReserva}
    //                )
    //                setDepositosModalVisible(true)
    //           }}
    //         />
    //       </Tooltip> 
    //       <Tooltip title="Cargos">
    //               <Button
    //                 type="link"
    //                 icon={<DollarOutlined />}
    //                 size="small"
    //                 onClick={() => {
    //                   setReservaCargos({
    //                     Nombre: record.Nombre,
    //                     NumReserva: record.NumReserva
    //                   });
    //                   setCargosModalVisible(true);
    //                 }}
    //               />
    //             </Tooltip>                   


    //           <Tooltip title="Editar">
    //             <Button
    //               type="primary"
    //               icon={<EditOutlined />}
    //               size="small"
    //               onClick={() => navigate(`/reservas/${record.NumReserva}`)}
    //             />
    //           </Tooltip>                

          
    //       {!record.Anulada && !record.Facturado && (
    //         <Tooltip title="Anular">
    //           <Popconfirm
    //             title="¿Anular esta reserva?"
    //             description="Esta acción marcará la reserva como anulada"
    //             onConfirm={() => handleAnularReserva(record.NumReserva)}
    //             okText="Sí"
    //             cancelText="No"
    //           >
    //             <Button
    //               type="dashed"
    //               danger
    //               icon={<CloseOutlined />}
    //               size="small"
    //             />
    //           </Popconfirm>
    //         </Tooltip>
    //       )}

    //       {!record.Facturado && (
    //         <Tooltip title="Facturación">
    //           <Button
    //             type="primary"
    //             icon={<FileTextOutlined />}
    //             size="small"
    //             onClick={() => {
    //               setReservaSeleccionada(record);
    //               setFacturacionModalVisible(true);
    //             }}
    //           />
    //         </Tooltip>          
    //       )}
          
    //       {!record.Facturado && (
    //         <Tooltip title="Eliminar">
    //           <Popconfirm
    //             title="¿Eliminar esta reserva?"
    //             description="Esta acción no se puede deshacer"
    //             onConfirm={() => handleEliminarReserva(record.NumReserva)}
    //             okText="Sí"
    //             cancelText="No"
    //             okButtonProps={{ danger: true }}
    //           >
    //             <Button
    //               danger
    //               icon={<DeleteOutlined />}
    //               size="small"
    //             />
    //           </Popconfirm>
    //         </Tooltip>
    //       )}
    //     </Space>
    //   ),
    // },
  ];

const buscarAgencias = async (texto) => {
  // Permitir búsqueda con 0 caracteres (para mostrar todas al hacer focus)
  setBuscandoAgencias(true);
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(
      `${BASE_URL}/api/agencias?search=${texto || ''}&pageSize=50`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    
    // Transformar datos al formato que espera Select
    const opciones = (response.data.data || []).map(agencia => ({
      value: agencia.Codigo,
      label: `${agencia.Codigo} - ${agencia.Nombre}`
    }));
    
    setOpcionesAgencias(opciones);
  } catch (error) {
    console.error('Error buscando agencias:', error);
    message.error('Error al cargar agencias');
  } finally {
    setBuscandoAgencias(false);
  }
};

const buscarSubagencias = async (texto) => {
  // Permitir búsqueda con 0 caracteres
  setBuscandoSubagencias(true);
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(
      `${BASE_URL}/api/subagencias?search=${texto || ''}&pageSize=50`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    
    // Transformar datos al formato que espera Select
    const opciones = (response.data.data || []).map(sub => ({
      value: sub.Codigo,
      label: `${sub.Codigo} - ${sub.Nombre}`
    }));
    
    setOpcionesSubagencias(opciones);
  } catch (error) {
    console.error('Error buscando subagencias:', error);
    message.error('Error al cargar subagencias');
  } finally {
    setBuscandoSubagencias(false);
  }
};
  
  


  // Componente de estadísticas
    const EstadisticasReservas = () => (
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
            <Col span={6}>
                <Statistic 
                    title="Total Reservas" 
                    value={estadisticas.total}
                    prefix={<CalendarOutlined />}
                    valueStyle={{ color: '#1890ff' }}
                />
            </Col>
            <Col span={6}>
                <Statistic 
                    title="Activas" 
                    value={estadisticas.activas}
                    valueStyle={{ color: '#52c41a' }}
                />
            </Col>
            <Col span={6}>
                <Statistic 
                    title="Facturadas" 
                    value={estadisticas.facturadas}
                    valueStyle={{ color: '#faad14' }}
                />
            </Col>
            <Col span={6}>
                <Statistic 
                    title="Anuladas" 
                    value={estadisticas.anuladas}
                    valueStyle={{ color: '#ff4d4f' }}
                />
            </Col>
        </Row>
    );

  
  // Si estamos en modo edición o visualización de una reserva específica
  if (editMode || currentReserva) {
    return (
      <PageContainer
        title={currentReserva ? `Reserva #${currentReserva.NumReserva}` : 'Nueva Reserva'}
        subtitle={currentReserva ? currentReserva.Nombre : 'Crear nueva reserva'}
        icon={<CalendarOutlined />}
        loading={loading}
        onRefresh={() => currentReserva && fetchReserva(currentReserva.NumReserva)}
        extra={
          <Space>
  
<div style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        backgroundColor: '#fff',
        padding: '16px 0',
        marginBottom: '16px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        borderBottom: '1px solid #f0f0f0'
      }}>
        <div style={{ 
          maxWidth: '1200px', 
          margin: '0 auto',
          padding: '0 24px' 
        }}>
          <Row align="middle" justify="space-between">
            <Col>
              <Space>

                {currentReserva && (
                  <Space>
                    {currentReserva.Anulada ? (
                      <Tag color="red">ANULADA</Tag>
                    ) : currentReserva.Facturado ? (
                      <Tag color="orange">FACTURADA</Tag>
                    ) : (
                      <Tag color="green">ACTIVA</Tag>
                    )}
                    <Tag color="blue">Entrada: {dayjs(currentReserva.Entrada).format('DD/MM/YY')}</Tag>
                    <Tag color="blue">Salida: {dayjs(currentReserva.Salida).format('DD/MM/YY')}</Tag>
                  </Space>
                )}
              </Space>
            </Col>
            
            <Col>
              <Space>
                {editMode ? (
                  <>
                    <Button
                      icon={<SaveOutlined />}
                      type="primary"
                      onClick={handleGuardarReserva}
                      loading={loading}
                      size="middle"
                    >
                      Guardar
                    </Button>
                    <Button
                      icon={<CloseOutlined />}
                      onClick={handleCancelarEdicion}
                      size="middle"
                    >
                      Cancelar
                    </Button>
                    

                  </>
                ) : (
                  <>
                    <Button
                      icon={<EditOutlined />}
                      type="primary"
                      onClick={() => setEditMode(true)}
                      size="middle"
                    >
                      Editar
                    </Button>
                    <Button
                      icon={<EyeOutlined />}
                      onClick={() => window.history.back()}
                      size="middle"
                    >
                      Volver a Lista
                    </Button>
                    {/* Botón de Depósitos */}
                    <Button 
                      type="link"
                      icon={<CreditCardOutlined />}
                      //type="dashed"
                      onClick={() => {
                                        setReservaDepositos(
                                          { Nombre:currentReserva.Nombre,NumReserva:currentReserva.NumReserva}
                                        )
                                        setDepositosModalVisible(true)}
                      }
                      size="middle"
                    >
                      Depósitos
                    </Button>                    

                    <Button
                      type="link"
                      icon={<DollarOutlined />}
                      size="small"
                      onClick={() => {
                        setReservaCargos({
                          Nombre: currentReserva.Nombre,
                          NumReserva: currentReserva.NumReserva
                        });
                        setCargosModalVisible(true);
                      }}
                    >
                      Cargos
                    </Button>
                  </>
                )}
              </Space>
            </Col>
          </Row>
        </div>
      </div>              
          </Space>
        }        
      >

         

  

<Modal
  title={`Buscar ${tipoBusqueda === 'agencia' ? 'Agencia' : tipoBusqueda === 'subagencia' ? 'Subagencia' : 'Particular'}`}
  open={modalBusquedaVisible}
  onCancel={() => setModalBusquedaVisible(false)}
  width={800}
  footer={null}
  destroyOnClose={true}
  afterClose={() => {
    // Limpiar estados cuando se cierra
    setDatosBusqueda([]);
    setFiltroBusqueda('');
  }}
>
  <Space direction="vertical" style={{ width: '100%' }}>
    <Input.Search
      placeholder={`Buscar por código o nombre...`}
      value={filtroBusqueda}
      onChange={(e) => setFiltroBusqueda(e.target.value)}
      onSearch={(value) => buscarDatos(tipoBusqueda, value, 1)}
      style={{ marginBottom: 16 }}
    />
    
    <Table
      columns={[
        {
          title: 'Código',
          dataIndex: 'Codigo',
          key: 'Codigo',
          width: 100,
        },
        {
          title: 'Nombre',
          dataIndex: 'Nombre',
          key: 'Nombre',
          ellipsis: true,
        },
        {
          title: 'Teléfono',
          dataIndex: 'Telefono',
          key: 'Telefono',
          width: 120,
        },
        {
          title: 'Acción',
          key: 'accion',
          width: 80,
          render: (_, record) => (
            <Button
              type="primary"
              size="small"
              onClick={() => seleccionarElemento(record)}
            >
              Seleccionar
            </Button>
          ),
        },
      ]}
      dataSource={datosBusqueda}
      rowKey="Codigo"
      loading={cargandoBusqueda}
      pagination={paginacionBusqueda}
      onChange={(pagination) => {
        buscarDatos(tipoBusqueda, filtroBusqueda, pagination.current);
      }}
      size="small"
    />
  </Space>
</Modal>

      </PageContainer>
    );
  }
  




  // Vista principal de lista de reservas
  return (
    <PageContainer
      title="Gestión de Reservas"
      subtitle={`${reservas.length} reservas registradas`}
      icon={<CalendarOutlined />}
      loading={tableLoading}
      onRefresh={fetchReservas}
      // onCreate={handleNuevaReserva}
      onCreate={handleNuevaReservaNueva}
      // badgeCount={estadisticas.total}
      badgeStatus="processing"
      // extra={
      //   // <Tag color="blue" style={{ fontSize: 14, padding: '4px 12px', borderRadius: 20 }}>
      //   //   <strong>{estadisticas.length}</strong> reservas
      //   // </Tag>
                       
      // }
      cardStyle={{
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
      }}
    >
      {/* Estadísticas */}
      <EstadisticasReservas />
      
      {/* Filtros */}
      <FiltrosReservas 
        filtros={filtros}
        setFiltros={setFiltros}
        opcionesAgencias={opcionesAgencias}
        opcionesSubagencias={opcionesSubagencias}
        buscandoAgencias={buscandoAgencias}
        buscandoSubagencias={buscandoSubagencias}
        buscarAgencias={buscarAgencias}
        buscarSubagencias={buscarSubagencias}
        handleAplicarFiltros={handleAplicarFiltros}
        handleLimpiarFiltros={handleLimpiarFiltros}
        imprimirReservas={generarPDF}
        reservasFiltradas={filteredData}
      />


      
      {/* Tabla de reservas */}
      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey="NumReserva"
        loading={tableLoading}
        scroll={{ x: 1200 }}
        pagination={pagination}
        onChange={handleTableChange}
        style={{
          borderRadius: '8px',
          overflow: 'hidden'
        }}
        onRow={(record) => ({
          onDoubleClick: () => {
              navigate(`/reservas/${record.NumReserva}`);
          },
          style: { cursor: 'pointer' } // opcional para que se vea clicable
        })}        
      />


      <DepositosReserva
          numReserva={reservaDepositos?.NumReserva}
          nombreCliente={reservaDepositos?.Nombre}
          visible={depositosModalVisible}
          onClose={() => setDepositosModalVisible(false)}
          onDepositoCreado={() => {}}
      />

      <CargosReserva
        numReserva={reservaCargos?.NumReserva}
        Reserva={reservaCargos}
        nombreCliente={reservaCargos?.Nombre}
        visible={cargosModalVisible}
        onClose={() => setCargosModalVisible(false)}
        onCargoCreado={() => {
          // Recargar si es necesario
        }}
      />      

      <Facturacion
        reserva={reservaSeleccionada}
        visible={facturacionModalVisible}
        onClose={() => {
          setFacturacionModalVisible(false);
          setReservaSeleccionada(null);
        }}
      />      
    </PageContainer>
  );
};

const FiltrosReservas = React.memo(({ 
  filtros, 
  setFiltros, 
  opcionesAgencias, 
  opcionesSubagencias,
  buscandoAgencias,
  buscandoSubagencias,
  buscarAgencias,
  buscarSubagencias,
  handleAplicarFiltros,
  handleLimpiarFiltros,
  imprimirReservas,reservasFiltradas
}) => (
  <Card 
    title="Filtros de búsqueda" 
    size="small" 
    style={{ marginBottom: 16 }}
    extra={
      <Space>
        <Button 
          icon={<SearchOutlined />} 
          type="primary" 
          onClick={handleAplicarFiltros}
          size="small"
        >
          Buscar
        </Button>
        <Button 
          icon={<ReloadOutlined />} 
          onClick={handleLimpiarFiltros}
          size="small"
        >
          Limpiar
        </Button>
        <Button
          type="primary"
          onClick={() => imprimirReservas(reservasFiltradas)}
        >
          Imprimir reservas
        </Button>        
      </Space>
    }
  >
    <Row gutter={[16, 16]}>
      <Col span={6}>
        <div style={{ marginBottom: 8 }}><strong>Fecha Entrada:</strong></div>
        <RangePicker
          style={{ width: '100%' }}
          value={filtros.fechaEntrada}
          onChange={(dates) => setFiltros(prev => ({ ...prev, fechaEntrada: dates }))}
          format="DD/MM/YYYY"
        />
      </Col>
      <Col span={6}>
        <div style={{ marginBottom: 8 }}><strong>Fecha Salida:</strong></div>
        <RangePicker
          style={{ width: '100%' }}
          value={filtros.fechaSalida}
          onChange={(dates) => setFiltros(prev => ({ ...prev, fechaSalida: dates }))}
          format="DD/MM/YYYY"
        />
      </Col>
      <Col span={4}>
        <div style={{ marginBottom: 8 }}><strong>Agencia:</strong></div>
        <Select
          showSearch
          allowClear
          placeholder="Buscar agencia..."
          style={{ width: '100%' }}
          value={filtros.agencia || undefined}
          onChange={(value) => setFiltros(prev => ({ ...prev, agencia: value }))}
          // Usar filterOption para filtrar localmente
          filterOption={(input, option) => 
            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          loading={buscandoAgencias}
          notFoundContent="No se encontraron agencias"
          options={opcionesAgencias}
          onFocus={() => {
            if (opcionesAgencias.length === 0) {
              buscarAgencias('');
            }
          }}
          dropdownMatchSelectWidth={false}
        />
      </Col>
      <Col span={4}>
        <div style={{ marginBottom: 8 }}><strong>Subagencia:</strong></div>
        <Select
          showSearch
          allowClear
          placeholder="Buscar subagencia..."
          style={{ width: '100%' }}
          value={filtros.subagencia || undefined}
          onChange={(value) => setFiltros(prev => ({ ...prev, subagencia: value }))}
          onSearch={buscarSubagencias}
          filterOption={false}
          loading={buscandoSubagencias}
          notFoundContent={buscandoSubagencias ? 'Buscando...' : 'No se encontraron subagencias'}
          options={opcionesSubagencias}
          onFocus={() => buscarSubagencias('')}
          dropdownMatchSelectWidth={false}
        />
      </Col>
      <Col span={4}>
        <div style={{ marginBottom: 8 }}><strong>Nº Reserva:</strong></div>
        <Input
          placeholder="Número reserva"
          value={filtros.numReserva}
          onChange={(e) => setFiltros(prev => ({ ...prev, numReserva: e.target.value }))}
        />
      </Col>
      <Col span={6}>
        <div style={{ marginBottom: 8 }}><strong>Localizador:</strong></div>
        <Input
          placeholder="Localizador"
          value={filtros.localizador}
          onChange={(e) => setFiltros(prev => ({ ...prev, localizador: e.target.value }))}
        />
      </Col>
      <Col span={10}>
        <div style={{ marginBottom: 8 }}><strong>Nombre Cliente:</strong></div>
        <Input
          placeholder="Nombre del cliente"
          value={filtros.nombreCliente}
          onChange={(e) => setFiltros(prev => ({ ...prev, nombreCliente: e.target.value }))}
        />
      </Col>
    </Row>
  </Card>
));

export default Reservas;